import { useGetLeaderboard } from 'src/hooks'
import { Box, Grid } from '@mui/material'

import { Loader } from '../loader'
import { LeaderboardTable } from './leaderboard-table.component'

interface IProps {
  isMainPage?: boolean
}

export const LeaderboardComponent = ({ isMainPage }: IProps) => {
  const { data, isLoading } = useGetLeaderboard()

  if (isLoading || !data) {
    return isMainPage ? (
      <Loader />
    ) : (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100px',
        }}
      >
        <Loader isStatic />
      </Box>
    )
  }

  const { total, ongoing } = data

  return (
    <Grid container spacing={2} maxWidth={'1440px'}>
      {/* one table per ongoing challenge */}
      {ongoing.map((ch) => {
        if (!ch.count) {
          return
        }

        return (
          <Grid item xs={12} sm={6} md={4} key={ch.name}>
            <LeaderboardTable item={ch} />
          </Grid>
        )
      })}

      {/* overall (total) */}
      <Grid item xs={12} sm={6} md={4}>
        <LeaderboardTable item={total} isOverall />
      </Grid>
    </Grid>
  )
}
